;(function () {
  'use strict'
  angular.module('contrast.security').constant('passwordExpirationInterval', {
    NEVER: {
      label: 'Never',
      value: 0,
      translationId: 'detail_never',
      translationVariable: 0
    },
    THIRTY_DAYS: {
      label: '30 days',
      value: 30,
      translationId: 'detail_days_plural',
      translationVariable: 30
    },
    NINETY_DAYS: {
      label: '90 days',
      value: 90,
      translationId: 'detail_days_plural',
      translationVariable: 90
    },
    SIX_MONTHS: {
      label: '6 months',
      value: 180,
      translationId: 'detail_months_plural',
      translationVariable: 6
    },
    ONE_YEAR: {
      label: '1 year',
      value: 365,
      translationId: 'detail_years_singular',
      translationVariable: 1
    }
  })
})()
